/**
 * Staging-next environment settings
 *
 * This file is where you define overrides for any of the config settings that
 * should only be applied in the staging environment.
 *
 * The production environment is defined as 'process.env.LORE_ENV=staging'
 */

export default {

  /**
   * To override a config setting, specify the name of the config file you
   * want to override, followed by the settings you want to change.
   */

  auth0: {
    clientID: 'gYoDeBb1I25NlBrj75yz4QGYrb2UV7ig', // Staging SPA (staging tenant)
    redirectUri: 'https://steward-staging-next.communityshare.org/auth/callback',
  },

  connections: {
    default: {
      // apiRoot: 'https://adminstaging.communityshare.cloud',
      apiRoot: 'https://api-staging.communityshare.org/steward_v2'
      // apiRoot: 'https://communityshare-api-steward-dev-30155350e74d.herokuapp.com/steward_v2'
    },
    community: {
      apiRoot: 'https://api-staging.communityshare.org/community_v3'
    }
  },

  custom: {
    platformUrl: function() {
      return `https://app-staging-next.communityshare.org`;
    }
  },

  intercom: {
    enabled: false,
    appId: 'x2vk07yc',
    companyId: 'staging-admin',
    companyName: 'Staging (Admin)'
  },

  raven: {
    environment: 'staging-admin-next',
    enabled: true
  },

  fullstory: {
    enabled: false
  },

  dialogs: {
    showTransitions: true
  },

  statsig: {
    environment: 'staging'
  }
}
